// This icon file is generated automatically.
var PThunderboltOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.25 4.61H8.81l3.1-3.9c.06-.09 0-.21-.1-.21h-6a.12.12 0 00-.1.06l-4.05 7c-.05.08 0 .18.1.18H4.5l-1.4 5.59c-.03.12.12.2.21.12l9.04-8.62a.12.12 0 00-.09-.22zm-7.34 5.84l.94-3.77H3.4l2.96-5.12h3.51L6.61 5.68h3.3l-5 4.77z", "fill-rule": "nonzero" } }] }, "name": "p-thunderbolt", "theme": "outlined" };
export default PThunderboltOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PThunderboltOutlined.js
// module id = 3687
// module chunks = 0